import React from 'react';

export default function Loader({ isLoading }) {
  return (
    <>
      {isLoading && (
        <div className="loader">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      )}
    </>
  );
}
